<script lang="ts" setup>
import { type User, getAuth, onAuthStateChanged } from "@firebase/auth";

const user = ref<User|null>();

useHead({
	title: 'Delete Smoxy account',
	meta: [
		{ name: 'robots', content: 'noindex,nofollow' },
	],
})

onMounted(()=>{
	onAuthStateChanged(getAuth(), (usr) => {
		if (usr) {
			user.value = usr
		} else {
			console.log("onAuthStateChanged", "user is signed out")
			user.value = null
		}
	});
})

const logout = ()=>{
	console.log("logout")
	const auth = getAuth()	
	auth.signOut()
	login()
	/*
	reloadNuxtApp({
		path: "/data-deletion",
		ttl: 1000, // default 10000
	});*/
}

const login = ()=>{
	console.log("login")
	navigateTo('/login?redirect=/data-deletion')
}

const deleteUserData = ()=>{
	console.log("deleteUserData")
	user.value!.delete()
		.then(() => {
			// User deleted.
			console.log("user deleted")
			navigateTo("/success-delete-account")

		}).catch((error) => {
			// An error ocurred
			// ...
			console.error("error", error)
		});
}

const accountName = ()=>{
	const usr = user.value!
	if(usr.email && !usr.email.includes("privaterelay.appleid.com")){
		return usr.email
	}
	if(usr.displayName && usr.displayName?.length > 0){
		return usr.displayName + " uid: " + usr.uid 
	}
	return usr.email ?? usr.uid
}

</script>

<template>
	<div class="">

		<div class="overflow-x-hidden py-32 ">

			<div class="md:max-w-screen-md mx-auto px-10 md:px-0 text-center flex flex-col items-center justify-center">

				<div class="flex justify-center">
					<div class="bg-orange-100 text-orange-400 px-2 py-1 rounded-md">Danger Zone</div>
				</div>
				<h1 class="text-6xl mx-10 text-center text-orange-500">Account deletion</h1>
				<p v-if="user" class="mb-8 mt-4 text-xl max-w-96 text-gray-600 text-center">Are you sure you want to delete your account and all user data for <span class="text-bold text-primary-500">{{accountName()}}</span>? </p>
				<p v-else class="mb-8 mt-4 text-xl max-w-96 text-gray-600 text-center">Please log in to delete your user data.</p>
				
				<div v-if="user" class="h-auto my-2 flex flex-col">
					<Button data-umami-event="Delete User Data" @click="deleteUserData" class="rounded-lg bg-primary-500 text-white font-bold px-4 w-80">Yes, delete this user account</Button>
					<Button data-umami-event="Switch Account" class="text-primary-500 bg-transparent shadow-none mx-auto w-80" @click="logout">No, Change Account</Button>
				</div>
				<div v-else class="h-auto my-2 flex flex-col">
					<Button data-umami-event="Login" class="shadow-none text-white mx-auto w-80" @click="login">Login</Button>
				</div>
			</div>
		</div>	
</div>
</template>
